import { render, staticRenderFns } from "./candidate-detail-item.vue?vue&type=template&id=2ccd355f&scoped=true&"
import script from "./candidate-detail-item.vue?vue&type=script&lang=js&"
export * from "./candidate-detail-item.vue?vue&type=script&lang=js&"
import style0 from "./candidate-detail-item.vue?vue&type=style&index=0&id=2ccd355f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd355f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
